export default function PageTeam() {
  const widthClassName = 'col-md-5';
  const widthUnderHeading = '5px';

  return (

    <div className="space-y-4 px-4">
      <h2 className="text-xl font-bold">Team</h2>
      <h3 className="text-lg font-semibold" style={{ marginBottom: widthUnderHeading }}>Vaste artsen</h3>

      <div className="container">
        <div className="row">

          <div key='1' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/Tess_0138.jpg"
                alt="Foto Dr. Tess Haccuria"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Tess Haccuria</h5>
              </div>
            </div>
          </div>

          <div key='2' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/Barbara_0134.jpg"
                alt="Foto Dr. Barbara Gilis"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Barbara Gilis</h5>
              </div>
            </div>
          </div>

          <div key='3' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/Kathlyn_0157.jpg"
                alt="Foto Dr. Kathlyn Moehlig"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Kathlyn Moehlig</h5>
              </div>
            </div>
          </div>

          <div key='4' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/Eliah_0132.jpg"
                alt="Foto Dr. Eliah Borms"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Eliah Borms</h5>
              </div>
            </div>
          </div>

        </div>
      </div>

      <br />
      <h3 style={{ marginBottom: widthUnderHeading }}>Huisarts in opleiding</h3>

      <div className="container">
        <div className="row">

          <div key='1' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/2025_Foto_HAIO_Amber_Vermeiren_416px.jpg"
                alt="Foto Dr. Amber Vermeiren"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Amber Vermeiren</h5>
              </div>
            </div>
          </div>

        </div>
      </div>

      <br />

      <h3 style={{ marginBottom: widthUnderHeading }}>Secretaresse</h3>

      <div className="container">
        <div className="row">

          <div key='1' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/Stefanie_0137.jpg"
                alt="Foto Stefanie"
              />
              <div className="card-body">
                <h5 className="card-title">Stefanie</h5>
              </div>
            </div>
          </div>

        </div>
      </div>

      <br />


      <h3 style={{ marginBottom: widthUnderHeading }}>Psychotherapeute</h3>


      <div className="container">
        <div className="row">

          <div key='1' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/Annelien.jpg"
                alt="Foto Annelien"
              />
              <div className="card-body">
                <h5 className="card-title">Annelien</h5>

              </div>
            </div>
          </div>

        </div>
      </div>
      <br />
      <p>Welkom, ik ben Annelien.
      </p><p>
        Het leven loopt niet altijd zoals we zouden willen.
        Soms vinden we onze weg, soms raken we wat vast - zeker na ingrijpende of pijnlijke ervaringen.
        Dan kan het helpend zijn om er niet alleen voor te staan.
      </p><p>
        Als integratief psychotherapeut bied ik een warme en veilige ruimte waar jouw verhaal welkom is.
        Geen snelle oplossingen, wel een respectvolle samenwerking waarin we samen verkennen wat je
        belemmert en hoe we opnieuw beweging kunnen brengen in wat vastzit.
      </p><p>
        Mijn begeleiding stem ik zorgvuldig af op jouw tempo en behoeften, met oog voor jou als geheel - zowel mentaal als fysiek.
      </p><p>
        Je bent welkom op <strong>vrijdagnamiddag en donderdagvoormiddag</strong> in de praktijk in Waarloos.<br/>
        Je kan een afspraak maken door te bellen naar Stefanie op het algemene nummer van de praktijk.
      </p>
      <br />



      <h3 style={{ marginBottom: widthUnderHeading }}>Tabakoloog</h3>


      <div className="container">
        <div className="row">

          <div key='1' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/foto_tabocoloog_vierkant.jpg"
                alt="Foto Martijn"
              />
              <div className="card-body">
                <h5 className="card-title">Martijn</h5>

              </div>
            </div>
          </div>

        </div>
      </div>
      <br />
      <p>Martijn is tabakoloog en werkt <strong>twee donderdagen per maand</strong> op onze praktijk. Een afspraak maken kan via 0488/37.45.85 of via <strong><a href="mailto:tabakoloogfelix@gmail.com">tabakoloogfelix@gmail.com</a></strong>
      </p>
      <br />



      <h3 style={{ marginBottom: widthUnderHeading }}>Diëtiste</h3>


      <div className="container">
        <div className="row">

          <div key='1' className={widthClassName}>
            <div className="card" style={{ width: "100%" }}>
              <img
                className="card-img-top"
                src="/images/2025.05/Yana_vierkant.jpg"
                alt="Foto Yana Van Gastel"
              />
              <div className="card-body">
                <h5 className="card-title">Yana</h5>

              </div>
            </div>
          </div>

        </div>
      </div>
      <br />
      <p>
        <strong>Tel:</strong> 0470 85 68 65<br/>
        <strong>Afspraak:</strong> <a href="https://www.mtc-it4.be/patient/index.html#/appointments/multi/bjNkcWkyQmFRMkpDVTRFNndleFgzQmFscjgvMkp0L2JEd2lLTkZRSjF6TnVzOXF2QWNIL3NyeXVQUG1FVHRoag==">Afspraak.be - Weet en Eet</a><br/>
        <strong>Mail:</strong> <a href="mailto:yana@weeteneet.be">yana@weeteneet.be</a>
      </p><p>
        Als erkend diëtiste en diabeteseducator in opleiding begeleid ik mensen naar een gezonde, realistische en duurzame levensstijl.
        Voeding speelt een belangrijke rol in ons welzijn. Mijn doel is om samen met jou een evenwicht te vinden dat past bij jouw lichaam, levensstijl en persoonlijke voorkeuren.
      </p><p>
        Ik bied begeleiding op maat: geen strenge diëten of standaardlijstjes, maar haalbare adviezen die je op lange termijn kan volhouden.
      </p><p>
        Met een open, empathische en positieve aanpak streef ik ernaar dat jij je goed voelt. Samen zetten we kleine, duidelijke stappen richting een betere gezondheid.
      </p><p>
        Je bent van harte welkom op <strong>maandagvoormiddag</strong> in de praktijk te Waarloos.
      </p>


    </div>
  );
}
